/*
 * @FilePath: operateManageConfig.js
 * @Author: Aron
 * @Date: 2023-07-25 15:57:24
 * @LastEditors: hushun hushun@songshuai.com
 * @LastEditTime: 2025-07-22 19:50:13
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */

export default [
  {
    path: "teacherManagement",
    name: "teacherManagement",
    meta: {
      title: "分析员管理"
    },
    component: () =>
      import("@/views/Home/operateManage/teacherManagement/index.vue")
  },
  {
    path: "AccountSet",
    name: "AccountSet",
    meta: {
      title: "账户管理"
    },
    component: () =>
      import("@/views/Home/operateManage/AccountSet/AccountSet.vue")
  },
  {
    path: "QuickIdentity",
    name: "QuickIdentity",
    meta: {
      title: "自定义快捷身份"
    },
    component: () =>
      import("@/views/Home/operateManage/AccountSet/QuickIdentity.vue")
  },
  {
    path: "AuthorityDetails",
    name: "AuthorityDetails",
    meta: {
      title: "分配权限"
    },
    component: () =>
      import("@/views/Home/operateManage/AccountSet/AuthorityDetails.vue")
  },
  {
    path: "EmployeesAccount",
    name: "EmployeesAccount",
    meta: {
      title: "员工账号"
    },
    component: () =>
      import("@/views/Home/operateManage/EmployeesAccount/EmployeesAccount.vue")
  },
  {
    path: "addEmployee",
    name: "addEmployee",
    meta: {
      title: "添加员工"
    },
    component: () =>
      import("@/views/Home/operateManage/EmployeesAccount/addEmployee.vue")
  },
  {
    path: "ExperiencesAccount",
    name: "ExperiencesAccount",
    meta: {
      title: "员工学习账号"
    },
    component: () =>
      import("@/views/Home/operateManage/ExperiencesAccount/ExperiencesAccount.vue")
  },
  {
    path: "scoreCollected",
    name: "scoreCollected",
    meta: {
      title: "成绩收集（总）"
    },
    component: () =>
      import("@/views/Home/operateManage/scoreCollected/index.vue")
  },
  {
    path: "teacherScoreManage",
    name: "teacherScoreManage",
    meta: {
      title: "督学师的成绩管理"
    },
    component: () =>
      import("@/views/Home/operateManage/teacherScoreManage/index.vue")
  },
  {
    path: "SupervisorManage",
    name: "SupervisorManage",
    meta: {
      title: "督学管理"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorManage/index.vue")
  },
  {
    path: "scoreManage",
    name: "scoreManage",
    meta: {
      title: "成绩管理"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorManage/scoreManage.vue")
  },
  {
    path: "SupervisorData",
    name: "SupervisorData",
    meta: {
      title: "督学师数据"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorData/index.vue")
  },
  {
    path: "StudentDetails",
    name: "StudentDetails",
    meta: {
      title: "督学师明细"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorData/StudentDetails.vue")
  },
  {
    path: "SupervisorSummary",
    name: "SupervisorSummary",
    meta: {
      title: "督学师小结"
    },
    component: () =>
      import("@/views/Home/operateManage/SupervisorData/SupervisorSummary.vue")
  },
  {
    // path: 'SchoolDataBase/folderCompusManage/startFolder',
    path: 'SchoolDataBase/*',
    name: 'SchoolDataBase',
    meta: {
      title: "资料库"
    },
    component: () =>
      import("@/views/Home/operateManage/SchoolDataBase/SchoolDataBase.vue")
  },

  {
    path: "SchoolDataBase/folderCompusManage/startFolder",
    name: "SchoolDataBase",
    meta: {
      title: "资料库"
    },
    component: () =>
      import("@/views/Home/operateManage/SchoolDataBase/SchoolDataBase.vue")
  },
  // dddd
  
  {
    path: "ReportManage/account_value_statistical_report",
    name: "account_value_statistical_report",
    meta: {
      title: "代理商账户价值统计报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/account_value_statistical_report/index.vue"
      )
  },
  {
    path: "ReportManage/product_price_increase_order_report",
    name: "product_price_increase_order_report",
    meta: {
      title: "商品涨价订单报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/product_price_increase_order_report/index.vue"
      )
  },
  {
    path: "ReportManage/learning_machine_details",
    name: "learning_machine_details",
    meta: {
      title: "学习机报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/learning_machine_details/index.vue"
      )
  },
  {
    path: "ReportManage/sy_loudou_agent_orders",
    name: "sy_loudou_agent_orders",
    meta: {
      title: "漏斗-代理商订购报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_loudou_agent_orders/index.vue"
      )
  },
  {
    path: "ReportManage/sy_loudou_province_orders",
    name: "sy_loudou_province_orders",
    meta: {
      title: "漏斗-省订购报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_loudou_province_orders/index.vue"
      )
  },
  {
    path: "ReportManage/sy_non_loudou_agent_orders",
    name: "sy_non_loudou_agent_orders",
    meta: {
      title: "非漏斗-代理商订购报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_non_loudou_agent_orders/index.vue"
      )
  },
  {
    path: "ReportManage/sy_non_loudou_province_orders",
    name: "sy_non_loudou_province_orders",
    meta: {
      title: "非漏斗-省订购报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_non_loudou_province_orders/index.vue"
      )
  },
  {
    path: "ReportManage/sy_province_orders",
    name: "sy_province_orders",
    meta: {
      title: "省份订单报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_province_orders/index.vue"
      )
  },
  {
    path: "ReportManage/sy_province_activate",
    name: "sy_province_activate",
    meta: {
      title: "省份激活数据报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_province_activate/index.vue"
      )
  },
  {
    path: "ReportManage/sy_agent_replenishment",
    name: "sy_agent_replenishment",
    meta: {
      title: "代理商补货预估分析表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_agent_replenishment/index.vue"
      )
  },
  {
    path: "ReportManage/sy_orders_serials",
    name: "sy_orders_serials",
    meta: {
      title: "订单流水报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_orders_serials/index.vue"
      )
  },
  {
    path: "ReportManage/agent_split_order",
    name: "agent_split_order",
    meta: {
      title: "采购单分单报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/agent_split_order/index.vue"
      )
  },
  {
    path: "ReportManage/sy_recharge_details",
    name: "sy_recharge_details",
    meta: {
      title: "代理商充值明细报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/sy_recharge_details/index.vue"
      )
  },
  {
    path: "ReportManage/agent_up_down_data",
    name: "agent_up_down_data",
    meta: {
      title: "代理商升降级"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/agent_up_down_data/index.vue"
      )
  },
  {
    path: "ReportManage/region_agent_query",
    name: "region_agent_query",
    meta: {
      title: "区域代理商查询报表"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/region_agent_query/index.vue"
      )
  },
  {
    path: "ReportManage/store_stock_data_statistic",
    name: "store_stock_data_statistic",
    meta: {
      title: "各仓库库存数据统计"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/store_stock_data_statistic/index.vue"
      )
  },
  {
    path: "ReportManage/stock_data_statistic",
    name: "stock_data_statistic",
    meta: {
      title: "各商品库存数据统计"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/stock_data_statistic/index.vue"
      )
  },
  {
    path: "ReportManage/agent_sale_split_order",
    name: "agent_sale_split_order",
    meta: {
      title: "订单分单报表(销售版)"
    },
    component: () =>
      import(
        "@/views/Home/operateManage/StatisticAnalysis/agent_sale_split_order/index.vue"
      )
  },
  {
    path: "ReportManage/region_target_summary",
    name: "region_target_summary",
    meta: {
      title: "区代业绩目标统计"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/RegionTargetSummary/index.vue")
  },
  {
    path: "ReportManage/machine_use_area",
    name: "machine_use_area",
    meta: {
      title: "区域内使用设备查询"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/MachineUseArea/index.vue")
  },
  {
    path: "EquipmentValue",
    name: "EquipmentValue",
    meta: {
      title: "设备价值明细报表"
    },
    component: () =>
      import("@/views/Home/operateManage/StatisticAnalysis/ReconciliationData/EquipmentValue/index.vue"
      )
  },
  {
    path: "PurchaseValue",
    name: "PurchaseValue",
    meta: {
      title: "采购订单价值明细报表"
    },
    component: () =>
      import("@/views/Home/operateManage/StatisticAnalysis/ReconciliationData/PurchaseValue/index.vue"
      )
  },
  {
    path: "DeliverValue",
    name: "DeliverValue",
    meta: {
      title: "发货订单价值明细报表"
    },
    component: () =>
      import("@/views/Home/operateManage/StatisticAnalysis/ReconciliationData/DeliverValue/index.vue"
      )
  }
];
